(function($){
	// Ensure birthday helpers exist
	if (typeof window.changeToDatePicker !== 'function') {
		window.changeToDatePicker = () => {
			$('#birthdayInput').prop('type', 'date');
			$('#birthdayInput').off('click touchstart', window.changeToDatePicker);
		};
	}
	if (typeof window.changeToText !== 'function') {
		window.changeToText = () => {
			var $input = $('#birthdayInput');
			if (!$input.val()) {
				$input.prop('type', 'text');
				$input.on('click touchstart', window.changeToDatePicker);
			}
		};
	}
	if (typeof window.datePickerListener !== 'function') {
		window.datePickerListener = () => {
			$('#birthdayInput').on('click touchstart', window.changeToDatePicker);
			$('#birthdayInput').on('blur', window.changeToText);
		};
	}
	
	window.openRegisterLoginPopup = function(){
		console.log('openRegisterLoginPopup');
		$('.login-register__overlay').css({display:'block',opacity:'1'});
		$('#jsc-login-register-popup').addClass('open').css('display','flex');
		$('body').css('overflow','hidden');
		if (typeof window.datePickerListener === 'function') { window.datePickerListener(); }
	};
	window.closeRegisterLoginPopup = function(){
		$('#jsc-login-register-popup').removeClass('open').css('display','');
		$('.login-register__overlay').css({display:'none',opacity:'0'});
		$('body').css('overflow','');
		var currentLanguage = window.location.pathname.startsWith('/en') ? 'en' : 'jp';
		sessionStorage.setItem('popupClosed', 'true');
		sessionStorage.setItem('popupClosedLanguage', currentLanguage);
	};
	window.openRegisterPopup = function(){
		$('a[data-tab="login-popup-panel"]').removeClass('active');
		$('a[data-tab="register-popup-panel"]').addClass('active');
		$('#login-popup-panel').removeClass('active');
		$('#register-popup-panel').addClass('active');
		$('#recover-password-popup-panel').removeClass('active');
		if (typeof window.datePickerListener === 'function') { window.datePickerListener(); }
	};
	window.openLoginPopup = function(){
		$('a[data-tab="login-popup-panel"]').addClass('active');
		$('a[data-tab="register-popup-panel"]').removeClass('active');
		$('#login-popup-panel').addClass('active');
		$('#register-popup-panel').removeClass('active');
		$('#recover-password-popup-panel').removeClass('active');
	};
	window.openRecoverPasswordPopup = function(){
		$('a[data-tab="login-popup-panel"]').removeClass('active');
		$('a[data-tab="register-popup-panel"]').removeClass('active');
		$('#login-popup-panel').removeClass('active');
		$('#register-popup-panel').removeClass('active');
		$('#recover-password-popup-panel').addClass('active');
	};
	// Backwards compatibility: map old drawer functions to popup
	window.openRegisterLoginDrawer = window.openRegisterLoginPopup;
	window.closeRegisterLoginDrawer = window.closeRegisterLoginPopup;
	window.openRegisterDrawer = window.openRegisterPopup;
	window.openLoginDrawer = window.openLoginPopup;
	window.openRecoverPasswordDrawer = window.openRecoverPasswordPopup;
	// close on overlay click
	$(document).on('click','.login-register__overlay',function(){ closeRegisterLoginPopup(); });

	// close when clicking outside the popup content (backdrop)
	$(document).on('click','#jsc-login-register-popup',function(e){
		if (e.target === this) {
			closeRegisterLoginPopup();
		}
	});

	// close on Esc key (desktop)
	$(document).on('keydown',function(e){
		if ((e.key === 'Escape' || e.keyCode === 27) && $('#jsc-login-register-popup').hasClass('open')) {
			closeRegisterLoginPopup();
		}
	});

	// prevent native submit and submit via Enter
	$(document).on('keydown','form#customer_login input',function(e){ if(e.key==='Enter'){ e.preventDefault(); }});
	$(document).on('submit','#customer_login_popup',function(e){
		e.preventDefault();
		credentialChecking($(this).find('button.button.full')[0]);
	});

	window.login = function(email,password){
		var data={
			'customer[email]': email,
			'customer[password]': password,
			form_type: 'customer_login',
			utf8: '✓'
		};
		return $.ajax({ url:'/account/login', method:'post', data:data, dataType:'html', async:true });
	};
	window.credentialChecking = function(btn){
		var _this=$(btn);
		var $form=$('#customer_login_popup');
		var $email=$form.find('input[name="customer[email]"]').val();
		var $password=$form.find('input[name="customer[password]"]').val();
		var $errorBlock=$('#login-popup-panel #login-popup-error');
		var $errorList=$errorBlock.find('.errors ul');
		$errorList.empty();
		$errorBlock.addClass('d-none');
		$('.jsc-page-loading').show();
		login($email,$password)
			.done(function(html){
				// consider success ONLY if response indicates logged-in state
				var isLoggedIn = html.indexOf('customer-logged-in') !== -1 || html.indexOf('/account/logout') !== -1;
				if(!isLoggedIn){
					var errorItem=$('<li></li>').text('Incorrect email or password.');
					$errorList.append(errorItem);
					$errorBlock.removeClass('d-none');
					return;
				}
				$errorBlock.addClass('d-none');
				document.location.href='/account';
			})
			.always(function(){
				$('.jsc-page-loading').hide();
			});
	};

	window.register = function(email,password,firstName,lastName,customerTags,accepts_marketing){
		var data={
			'customer[email]': email,
			'customer[password]': password,
			'customer[first_name]': firstName,
			'customer[last_name]': lastName,
			'customer[tags]': customerTags,
			'customer[accepts_marketing]': accepts_marketing,
			form_type: 'create_customer',
			utf8: '✓'
		};
		return $.ajax({ url:'/account', method:'post', data:data, dataType:'html', async:true });
	};
	window.registerChecking=function(btn){
		var _this=$(btn);
		var $form=$('#create_customer_popup');
		var $firstName=$form.find('input[name="customer[first_name]"]').val();
		var $lastName=$form.find('input[name="customer[last_name]"]').val();
		var $email=$form.find('input[name="customer[email]"]').val();
		var $password=$form.find('input[name="customer[password]"]').val();
		var $birthday=$form.find('input[name="customer[note][Birthday]"]').val();
		var $accepts=$form.find('#newsletter').is(':checked');
		var $tags = [];
		var $errorMsg=$('#register-popup-panel #register-popup-error');
		$errorMsg.empty().hide();
		// Validation
		var errors=[];
		if(!$firstName || !$firstName.trim()){ errors.push('First name is required'); }
		if(!$lastName || !$lastName.trim()){ errors.push('Last name is required'); }
		var emailRegex=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if(!$email || !$email.trim()){ errors.push('Email is required'); }
		else if(!emailRegex.test($email)){ errors.push('Please enter a valid email address'); }
		if(!$password){ errors.push('Password is required'); }
		else if($password.length<6){ errors.push('Password must be at least 6 characters long'); }
		if(!$birthday || !$birthday.trim()){ errors.push('Birthday is required'); }
		if(errors.length>0){
			var html = errors.map(function(m){
				return '<div class="error-message"><p>'+m+'</p></div>';
			}).join('');
			$errorMsg.html(html).css('display','flex');
			return;
		}
		$('.jsc-page-loading').show();
		register($email,$password,$firstName,$lastName,$tags.join(','),$accepts)
			.done(function(html){
				var isLoggedIn = html.indexOf('customer-logged-in') !== -1 || html.indexOf('/account/logout') !== -1;
				if(!isLoggedIn){
					var match=html.match(/<div class=\"errors\">([\s\S]*?)<\/div>/);
					var msg = match?$(match[1]).text().trim():'Registration failed.';
					$errorMsg.html('<div class="error-message"><p>'+msg+'</p></div>').css('display','flex');
					return;
				}
				$errorMsg.addClass('d-none');
				document.location.href='/account';
			})
			.always(function(){
				$('.jsc-page-loading').hide();
			});
	};

	window.recoverPassword=function(email){
		var data={ email: email, form_type:'recover_customer_password', utf8:'✓' };
		return $.ajax({ url:'/account/recover', method:'post', data:data, dataType:'html', async:true });
	};
	window.recoverEmailChecking=function(btn){
		var _this=$(btn);
		var $form=$('#recover_customer_password_popup');
		var $email=$form.find('input[name="email"]').val();
		var $errorMsg=_this.siblings('.jsc-form-status__message.form-status__message--error');
		var $successMsg=_this.siblings('.jsc-form-status__message.form-status__message--success');
		$errorMsg.addClass('d-none').empty();
		$successMsg.addClass('d-none');
		$('.jsc-page-loading').show();
		recoverPassword($email)
			.done(function(html){
				if(html.indexOf('ไม่พบบัญชีผู้ใช้จากอีเมลนั้น')!==-1||html.indexOf('No account found with that email')!==-1){
					var errorItem=$('<li></li>').text('No account found with that email');
					$errorMsg.append(errorItem).removeClass('d-none');
				}else{
					$errorMsg.addClass('d-none');
					$successMsg.removeClass('d-none');
				}
			})
			.always(function(){
				$('.jsc-page-loading').hide();
			});
	};
})(window.jQuery || window.$); 